<template>
  <div
    class="list-card simple-click-hover"
    @mouseover="_cardMouseover"
    @mouseout="_cardMouseout"
    v-if="cardType === 1"
    @click="openCompDetail"
  >
    <!-- 公司logo -->
    <div class="img-body">
      <comp-icon
        :src="data.CompLogo"
        :width="50"
        :height="50"
      ></comp-icon>
    </div>

    <div class="card-info">
      <!-- 公司详情 -->
      <div class="comp-detail">
        <vip-level :width="14" :curData="data"></vip-level>
        <p class="text-clamp1" v-html="stringFilter(data.CompName)" :title="stringFilter(data.CompName)"></p>
      </div>
      <p class="text-clamp1" v-if="data.Province || data.City">{{data.Province}}&nbsp;&nbsp;{{data.City !== data.Province ? data.City : ''}}</p>
    </div>
    <slot name="footer"></slot>
  </div>

  <div
    @click="openCompDetail"
    class="list-card2 simple-click-hover"
    v-else
  >
    <!-- 公司logo -->
    <div class="img-body">
      <comp-icon
        :src="data.CompLogo"
        :width="165"
        :height="165"
      ></comp-icon>
    </div>

    <div class="card-info">
      <!-- 公司详情 -->
      <div class="card-mid" style="padding-bottom: 5px;">
        <p class="text-clamp2" v-html="stringFilter(data.CompName)"></p>
      </div>
    </div>
    <vip-level :curData="data" :width="14"></vip-level>

    <slot name="footer"></slot>
  </div>

</template>

<script>
import {AdvertsService} from '@digital-supply-chain/module'
import { OpenService } from "@/service";
import CompIcon from "/@/components/icon/comp-icon.vue";
import VipLevel from "/@/components/icon/vip-level.vue";

export default {
  components: {
    CompIcon,
    VipLevel,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    cardStyle: { dafault: {} },
    cardType: { default: 1 }
  },
  data() {
    return {};
  },
  methods: {
    stringFilter(value) {
      return value ? value.toString() : value;
    },
    _cardMouseover(e) {
      this.$emit('mouseover', e);
    },
    _cardMouseout(e) {
      this.$emit('mouseout', e);
    },
    openCompDetail() {
      const advId = this.data.advId || this.data.AdvId || '';
      if (advId) {
        AdvertsService.clickAdverts(advId);
      }
      OpenService.openCompDetail(this.data.CompID || this.data.CompId);
    }
  },
};
</script>

<style lang="less" scoped>
.list-card {
  position: relative;
  border: 1px solid #EEEEEE;
  font-size: 0;
  min-width: 230px;
  max-width: 280px;
  margin: 0 5px 10px 5px;
  flex: 1;
  text-decoration: none;
  background: #ffffff;
  height: 70px;
  .img-body{
    align-items: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 50px;
    position: absolute;
    left: 10px;
    top: 10px;
    img{
      object-fit: contain;
      max-width: 100%;
    }
  }
  .card-info{
    font-size: 16px;
    color: #000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-left: 70px;
    padding-right: 10px;
    p{
      margin: 0;
    }
    &>p{
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
    }
    .comp-detail{
      display: flex;
      align-items: center;
      p{
        padding-left: 4px;
      }
    }
  }
}


// 第二种类型
.list-card2 {
  position: relative;
  border: 1px solid #d6d6d6;
  font-size: 0;
  min-width: 130px;
  max-width: 160px;
  margin: 0 5px 10px 5px;
  flex: 1;
  text-decoration: none;
  background: #ffffff;
  display: block;
  .img-body{
    padding: 3px;
    align-items: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 120px;
    overflow: hidden;
    img{
      object-fit: contain;
      max-width: 100%;
    }
  }
  .card-mid {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 37px;
    padding: 5px 5px 0;
    // 产品名称
    p {
      overflow: hidden;
      font-size: 14px;
      color: #111a2a;
      margin: 0;
    }
    /deep/ em{
      font-style: initial;
      color: #dc0000;
    }
  }
  /deep/ .vip-level{
    position: absolute;
    left: 6px;
    top: 6px;
  }
}
</style>
